export default __webpack_public_path__ + "static/media/RMS.7fb60d548280a00278b395748e235ad4.webp";